import { useMemo } from 'react'
import { useRouteError } from 'react-router'
import { ErrorPage } from '../components/error-pages/error-page.tsx'
import { generateReference } from '../lib/reference.ts'

// RAL-162 board 1e: the standalone, signed-out frame — no shell to fall back on, so it carries
// its own wordmark. Attached to /sign-in and /sign-up (router.tsx), the only pre-auth routes
// that render real page content rather than redirecting straight through Clerk.
export default function AuthErrorBoundary() {
  const error = useRouteError()
  if (import.meta.env.DEV) console.error(error)

  const reference = useMemo(() => generateReference(), [])

  return (
    <ErrorPage
      variant="standalone"
      publisherStatus={{ state: 'unknown' }}
      reference={reference}
      onRetry={() => window.location.reload()}
    />
  )
}
